var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 80,
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    className: "iconify iconify--fxemoji",
    transform: "scale(-1 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A97DFF",
    d: "M56.613 60.427H43.952V10.114a2.798 2.798 0 0 1 2.798-2.798h7.065a2.798 2.798 0 0 1 2.798 2.798v50.313z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF473E",
    d: "M22.995 60.427H10.334V17.174a2.798 2.798 0 0 1 2.798-2.798h7.065a2.798 2.798 0 0 1 2.798 2.798v43.254z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00B1FF",
    d: "M39.804 60.427H27.142V37.023a2.798 2.798 0 0 1 2.798-2.798h7.065a2.798 2.798 0 0 1 2.798 2.798v23.404z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#A97DFF",
    d: "M56.613 60.427H43.952V10.114a2.798 2.798 0 0 1 2.798-2.798h7.065a2.798 2.798 0 0 1 2.798 2.798v50.313z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart);
export default __webpack_public_path__ + "static/media/chart.4d722f40176cfad00beb7e2c1a3013fc.svg";
export { ForwardRef as ReactComponent };